"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./WebSocket.scss");
var _SocketQueueMapping = require("./SocketQueueMapping");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SocketContainer = function SocketContainer(_ref) {
  var info = _ref.info,
    position = _ref.position,
    handleHideModal = _ref.handleHideModal;
  var skipWebSocket = ["api/crm-field/mapping/test-fields"];
  return info === null || info === void 0 ? void 0 : info.map(function (item, index) {
    var notShowSocket = skipWebSocket === null || skipWebSocket === void 0 ? void 0 : skipWebSocket.find(function (f) {
      var _item$responseStep, _item$responseStep$co;
      return item === null || item === void 0 ? void 0 : (_item$responseStep = item.responseStep) === null || _item$responseStep === void 0 ? void 0 : (_item$responseStep$co = _item$responseStep.config) === null || _item$responseStep$co === void 0 ? void 0 : _item$responseStep$co.url.includes(f);
    });
    if (!notShowSocket) {
      var _item$progress, _item$progress2, _item$progress3;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: index
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "socket-container ".concat(position ? position : "socket-center-center")
      }, /*#__PURE__*/_react.default.createElement("div", {
        key: "i",
        className: "socket toast"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "socket-hrader"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "socket-title"
      }, "Processing...", /*#__PURE__*/_react.default.createElement("i", {
        className: "mdi mdi-window-minimize",
        onClick: function onClick() {
          return handleHideModal(item.id);
        }
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "socket-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-bar progress-bar-striped progress-bar-animated",
        role: "progressbar",
        "aria-valuenow": Math.round(item === null || item === void 0 ? void 0 : (_item$progress = item.progress) === null || _item$progress === void 0 ? void 0 : _item$progress.percent),
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        style: {
          width: "".concat(Math.round(item === null || item === void 0 ? void 0 : (_item$progress2 = item.progress) === null || _item$progress2 === void 0 ? void 0 : _item$progress2.percent), "%")
        }
      }, Math.round(item === null || item === void 0 ? void 0 : (_item$progress3 = item.progress) === null || _item$progress3 === void 0 ? void 0 : _item$progress3.percent), "%")), /*#__PURE__*/_react.default.createElement("p", {
        className: "socket-message mt-2"
      }, "Estimated time remaining:", " ", (item === null || item === void 0 ? void 0 : item.time) === "00:00:00" ? item !== null && item !== void 0 && item.queued ? _SocketQueueMapping.SocketQueueText : "calculating…" : item === null || item === void 0 ? void 0 : item.time)))), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-backdrop-socket socket-backdrop"
      }));
    }
  });
};
var _default = SocketContainer;
exports.default = _default;